import { render, staticRenderFns } from "./loadApp.vue?vue&type=template&id=d9bdac84&scoped=true&"
import script from "./loadApp.vue?vue&type=script&lang=js&"
export * from "./loadApp.vue?vue&type=script&lang=js&"
import style0 from "./loadApp.vue?vue&type=style&index=0&id=d9bdac84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bdac84",
  null
  
)

export default component.exports